export default{
  "Mute Video": "静音视频",
  "HitPaw Online Mute Video": "HitPaw 在线视频静音",
  "Fast and easy to remove sound from your video online": "快速轻松地在线从视频中删除声音",
  "Muting": "静音中",
  "Mute Failed": "静音失败",
  "Mute New": "静音新的（文件）"
};